import styled from 'styled-components';

export const ContainerTable = styled.div`
  .MuiDataGrid-cell.yellowCell {
    background-color: #f2f2b3;
  }
  .table .hideRightSeparator .MuiDataGrid-columnSeparator {
    display: none;
  }
`;
